import * as React from 'react';
import { buildStateProvider } from '@shared-ui/provided-state-context';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertySaveTripItem, PropertySaveTripItemSplitted } from '@shared-ui/lodging-property-details';
import { ValidatedInputsState } from '@shared-ui/trips-save-item';
import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
const SaveTripItemWrapper = ({
  inputs
}) => {
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();
  const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);
  const searchCriteriaPrimary = propertySearchCriteria.primary;
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  /**
   * Save Trip Item needs to have the latest search criteria so it can correctly save items
   * The searchCriteria in the inputs is cached on pageload and not updated when a user changes dates or rooms
   */
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(ValidatedInputsStateProvider, null, React.createElement(PropertySaveTripItem, {
    inputs: inputs,
    searchCriteria: searchCriteriaPrimary,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(ValidatedInputsStateProvider, null, React.createElement(PropertySaveTripItemSplitted, {
    inputs: inputs,
    searchCriteria: searchCriteriaPrimary,
    skipSsr: cSRPropertyDetailsQuery
  }))));
};
export const SharedUiSaveTripItemWrapper = withSharedUiPropertyDetails(SaveTripItemWrapper);
SaveTripItemWrapper.displayName = 'SharedUiSaveTripItemWrapper';